module.exports = __webpack_public_path__ + "assets/0f8fe3e829c2f08fd1724f973914d268.mp3";